import React from "react";
import { Link } from "react-router-dom";

export default function PageHero({ title, subtitle, num="01" }) {
  return (
    <section className="relative pt-12 pb-20 md:pt-20 md:pb-28 grid-bg overflow-hidden border-b border-[#ececef] bg-[#fafafa]">
      <div className="absolute -top-20 -right-20 w-[500px] h-[500px] rounded-full opacity-20 blur-3xl" style={{background:'radial-gradient(circle, #ef2435, transparent 70%)'}}/>
      <div className="max-w-[1500px] mx-auto px-5 md:px-8 relative">
        <nav className="font-mono text-xs text-gray-500 mb-6">
          <Link to="/" className="hover:text-[#ef2435]">/HOME</Link> <span className="mx-2">·</span> <span className="text-[#ef2435]">/{title.toUpperCase().replace(/ /g,'_')}</span>
        </nav>
        <div className="flex items-end justify-between gap-6 flex-wrap">
          <div>
            <span className="num-badge block mb-2">[{num}]</span>
            <h1 className="giant-text text-6xl md:text-8xl lg:text-9xl font-bold">{title}</h1>
            {subtitle && <p className="text-lg text-gray-600 max-w-2xl leading-relaxed mt-6">{subtitle}</p>}
          </div>
          <div className="font-mono text-xs text-gray-500 hidden md:block">
            <p>SSC · READY MIX</p>
            <p>CONCRETE_DIVISION</p>
            <p className="text-[#ef2435] mt-2">— STATUS: ACTIVE</p>
          </div>
        </div>
      </div>
    </section>
  );
}
